import NotSureOrPreference from 'components/Header/BeautyPreferences/NotSureOrPreference/NotSureOrPreference';
import { withNotSureOrPreferenceProps } from 'viewModel/header/beautyPreferences/notSureOrPreference/withNotSureOrPreferenceProps';

const ConnectedNotSureOrPreference = withNotSureOrPreferenceProps(NotSureOrPreference);

export default ConnectedNotSureOrPreference;
